<template>
    <div>
        <div class="clearfix mb10 mt10">
            <div class="fl" v-if="isAll">
                <el-checkbox class="ml15" v-model="selected" @change="changeSelected">来源</el-checkbox>
            </div>
            <div class="fr">
                <div class="search-container primary">
                    <div class="form-box">
                        <input class="input-field" v-model="title" placeholder="招标标题"/>
                        <button class="search-btn" @click="getCallBidDocList()"><i class="icon iconfont icon-search"></i></button>
                    </div>
                </div>
            </div>
        </div>
        <div class="table-layout">
            <el-table :height="500+'px'" ref="multipleTable" :data="callBidDocList" border tooltip-effect="dark" style="width: 100%" @current-change="handleCurrentChange">
                <!--<el-table-column align="center" type="selection" width="55"></el-table-column>-->
                <el-table-column width="55" v-if="showSelect">
                    <template slot-scope="rows">
                        <div class="copy-radio" :class="{'circle' : checlCallBidDoc!= null && checlCallBidDoc.id == rows.row.id}">
                            <div class="circle-dot"></div>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="no" label="招标单号" width="183">
                    <template slot-scope="rows">
                        <a v-if="isAll" class="swb-btn-link" @click.stop="toCallBidDocList(rows.row.no)">{{rows.row.no}}</a>
                        <span v-else>{{rows.row.no}}</span>
                    </template>
                </el-table-column>
                <el-table-column align="left" prop="title" label="招标标题"></el-table-column>
                <el-table-column align="left" prop="winMerchantName" label="中标方"></el-table-column>
                <el-table-column align="left" width="150" prop="winContactName" label="联系人"></el-table-column>
                <el-table-column align="left" width="120" prop="winContactTel" label="联系电话"></el-table-column>
                <el-table-column align="left" width="200" prop="winContactEmail" label="联系邮箱"></el-table-column>
                <el-table-column align="center" width="180" prop="resultPublishTime" label="结果公布时间"></el-table-column>
            </el-table>
        </div>

        <div class="block pagination-layout">
            <el-pagination background class="mt10" :page-size="pageSize" :page-sizes="pageSizes" :current-page="pageNumber" :total="totalCount" @current-change="handlePageChange" @size-change="handleSizeChange" layout="total, sizes, prev, pager, next, jumper"></el-pagination>
        </div>
    </div>
</template>

<script>

    import { Utils } from '../../app.base'
    import { Vue, MsgBox } from '../../app.vues'
    import { getDefaultPageSizes } from '../../app.conf'

    import callBidApi from '../../api/callBid'

    export default {
        name: 'swb-call-bid-doc-for-select',
        desc: '选择招标书(合同用)',
        props: {
            rowId: {
                type: Number,
                default: null
            },
            showSelect: {
                type: Boolean
            },
            toCallBidDoc: {
                type: Function
            },
            type: {
                type: String
            },
            isAll: {
                type: Boolean
            },
            filter: {
                type: Object,
                default: function () {
                    return {};
                }
            }
        },
        data: function () {
            return {
                //
                pageNumber: 1,
                totalCount: 1,
                pageSize: null,
                pageSizes: getDefaultPageSizes(),
                //
                callBidDocList: [],
                title: null,

                dealState: {},
                allBidState: {},

                checlCallBidDoc: {
                    id: null
                },
                bidDocFlag: {},
                selected: false
            }
        },
        created: function () {
            //保持pageSize的一致性
            this.pageSize = this.pageSizes.first();
            //
            if(this.rowId != null && this.rowId != "") {
                this.checlCallBidDoc.id = this.rowId;
                if(this.isAll) {
                    this.selected = true;
                }
            }

            this.dealState = getEnumInfoWith("callBidDocState", 'name', 'Deal');
            this.allBidState = getEnumInfoWith("callBidDocState", 'name', 'All');

            this.bidDocFlag = getEnumInfoWith("bizSrcFlag", 'name', 'BidDoc');

            this.getCallBidDocList();
        },
        methods: {
            changeSelected() {
                this.getCallBidDocList();
            },
            handleSizeChange: function (val) {
                let curStartIndex = (this.pageNumber - 1) * this.pageSize;
                this.pageSize = val;
                let newPageNumber = Math.max(1, Math.ceil(curStartIndex / this.pageSize));
                this.handlePageChange(newPageNumber);
            },
            handlePageChange: function (val) {
                this.pageNumber = val;
                this.getCallBidDocList();
            },
            getCallBidDocList: function () {
                let self = this;

                let postData = {};
                postData.pagination = {
                    pageSize: self.pageSize,
                    pageNumber: self.pageNumber,
                };
                let filterItems = Utils.merge({}, self.filter);

                if(self.rowId != null && self.rowId != '' && self.selected) {
                    filterItems.id = self.rowId;
                } else if(self.selected) {
                    self.callBidDocList = [];
                    return false;
                }

                if(!Utils.isNoB(self.title)) {
                    filterItems.title = self.title;
                }
                if(self.isAll) {
                    filterItems.callBidState = self.allBidState.value;
                } else {
                    filterItems.callBidState = self.dealState.value;
                }
                if(self.type == 'goods') {
                    filterItems.goodsFlag = true;
                    filterItems.servcFlag = false;
                } else if(self.type == 'goodsAndServc') {
                    filterItems.goodsFlag = true;
                    filterItems.servcFlag = true;
                } else {
                    filterItems.servcFlag = true;
                    filterItems.goodsFlag = false;
                }
                filterItems.forAll = true;
                postData.filterItems = filterItems;
                let lastMsgBoxDlg = MsgBox.loading();
                callBidApi.getCallBidDocList(postData, function (result) {
                    lastMsgBoxDlg.close();
                    if(result.type == 'info') {
                        let rowId = self.rowId;
                        let itemList = result.data.rows;
                        if(rowId != null && self.selected) {
                            if(itemList != null && itemList.length > 0) {
                                for(var i = 0; i < itemList.length; i++) {
                                    let item = itemList[i];
                                    if(rowId != null && rowId == item.id) {
                                        self.checlCallBidDoc = Utils.merge({}, item);
                                    }
                                }
                            }
                        }
                        self.callBidDocList = itemList;
                        //
                        let pagination = result.data.pagination;
                        self.totalCount = pagination.totalCount;
                        self.pageNumber = pagination.pageNumber;
                        self.pagesize = pagination.pageSize;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            handleCurrentChange(val) {
                this.checlCallBidDoc = Utils.merge({}, val);
            },
            getDlgResult: function () {
                let self = this;
                let result = null;
                //
                let checlCallBidDoc = self.checlCallBidDoc;
                if(checlCallBidDoc.id != null) {
                    result = {};
                    if(self.isAll) {
                        result.srcId = checlCallBidDoc.id;
                        result.srcWinId = checlCallBidDoc.winBidDocId;
                        result.srcFlag = self.bidDocFlag.value;
                    } else {
                        result.type = 'info';
                        result.data = checlCallBidDoc;
                    }
                }
                return result;
            },
            toCallBidDocList: function (no) {
                this.toCallBidDoc.call(parent, no);
            }
        }
    }

</script>



// WEBPACK FOOTER //
// src/compo/callbid/CallBidDocForSelect.vue